import React from 'react';
import { getPackageBaseUrl } from 'owa-config';
import { urlResolve } from 'mini-common-utils/lib/utils/urlResolve';

const NETWORK_ERROR_IMAGE = 'resources/images/networkError.svg';
const NETWORK_ERROR_DARK_IMAGE = 'resources/images/networkErrorDark.svg';

/**
 * Network error SVG Icon
 */
export const NetworkErrorIcon = ({ isDarkMode }): JSX.Element => (
    <img
        src={urlResolve(
            getPackageBaseUrl(),
            isDarkMode ? NETWORK_ERROR_DARK_IMAGE : NETWORK_ERROR_IMAGE
        )}
        aria-hidden
        alt=""
        role="presentation"
    />
);
